export enum RegisterFailedCause {
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  EMAIL_IN_USE = 'EMAIL_IN_USE'
}
